import { render, staticRenderFns } from "./geo_enfermedades_sivigila.vue?vue&type=template&id=3503fd0c"
import script from "./geo_enfermedades_sivigila.vue?vue&type=script&lang=js"
export * from "./geo_enfermedades_sivigila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports